/**
 * @ngdoc services
 * @memberof mercury.modules.stock
 * @name StockItemSuperGroups
 */
angular.module('mercury.modules.stock.item')
.factory('StockItemSuperGroups', ["$resource", "settings", function($resource, settings) {
  var StockItemSuperGroups = $resource(settings.apiHost + '/r/StockItemSuperGroups/:id', {id: '@id'}, {patch: {method: 'PATCH'}});

  /**
   * [getAll description]
   *
   * @memberof StockItemSuperGroups
   * @return {?} [description]
   */
  function getAll() {
    return StockItemSuperGroups.query();
  }

  /**
   * [updateXeroAccount description]
   *
   * @memberof StockItemSuperGroups
   * @param  {?} id          [description]
   * @param  {?} xeroAccount [description]
   * @return {?}             [description]
   */
  function updateXeroAccount(id, xeroAccount) {
    return StockItemSuperGroups.patch({id: id}, {xeroAccountCode: xeroAccount}).$promise;
  }

  return {
    getAll: getAll,
    updateXeroAccount: updateXeroAccount
  };
}]);
